import React, { Component } from "react";

// Helper
import {
  formatImage,
  formatPercentage,
  formatValidUntil,
  formatVoucherIcon,
} from "../../helpers/FormatVoucher";

// Style
import { VoucherCarouselCardStyled } from "./style";

class VoucherCarousel extends Component {
  render() {
    const { data } = this.props;

    return (
      <VoucherCarouselCardStyled>
        <div
          onClick={(e) => this.props.onClick(data, e)}
          onMouseDown={this.props.onMouseDown}
        >
          <div className="discount-percentage">
            <p>{formatPercentage(data.item_price, data.package_price)}</p>
            <p>
              <small>OFF</small>
            </p>
          </div>
          <div className="d-flex voucher-card-container">
            <div className="voucher-image-container">
              <img
                className="img voucher-image"
                alt={"voucher"}
                src={formatImage(data)}
              />
            </div>
            <div className="voucher-info pl-3">
              <h3 className="title">{data.package_title}</h3>
              <p className="valid-till">
                Valid Until: {formatValidUntil(data.package_use_date_end)}
              </p>
              <p className="sales">Sales {data.sales}</p>
              <div className="d-flex justify-content-between align-items-end">
                <div className="price-container">
                  <p className="price">RM {data.package_price}</p>
                  <p className="actual-price">RM {data.item_price}</p>
                </div>
                <img
                  alt="icon"
                  src={formatVoucherIcon(data)}
                  className="voucher-icon"
                />
              </div>
            </div>
          </div>
        </div>
      </VoucherCarouselCardStyled>
    );
  }
}
export default VoucherCarousel;
